export const OpenApiExtensions = Object.freeze({
  RESOURCE_ID: 'x-cb-resource-id',
  RESOURCE_NAME: 'x-cb-resource-title',
  SORT_ORDER: 'x-cb-sort-order',
  OPERATION_METHOD_NAME: 'x-cb-operation-method-name',
  OPERATION_NOTES: 'x-cb-operation-notes',
  IS_LIST_OPERATION: 'x-cb-operation-is-list',
  IS_IDEMPOTENT_OPERATION: 'x-cb-operation-is-idempotent',
  IS_RESTRICTED: 'x-cb-restricted',
  IS_CUSTOM_FIELD_SUPPORTED: 'x-cb-is-custom-fields-supported',
  IS_FILTER_PARAMETER: 'x-cb-is-filter-parameter',
  DEPRECATED_ENUM_VALUES: 'x-cb-deprecated-enum-values',
  RESOURCE_PATH_NAME: 'x-cb-resource-path-name',
  IS_GLOBAL_ENUM: 'x-cb-is-global-enum',
  IS_MONEY_COLUMN: 'x-cb-is-money-column',
  IS_COMPOSITE_ARRAY_REQUEST_BODY: 'x-cb-is-composite-array-request-body',
  IS_DEPENDANT_ATTRIBUTE: 'x-cb-is-dependent-attribute',
  SUB_RESOURCE_NAME: 'x-cb-sub-resource-name',
  FILTER_NAME: 'x-cb-sdk-filter-name',
  HIDDEN_FROM_SDK: 'x-cb-hidden-from-client-sdk',
  SUB_DOMAIN: 'x-cb-operation-sub-domain-name',
  IS_EXTERNAL_ENUM: 'x-cb-is-external-enum',
  IS_SDK_GEN_SEPARATE: 'x-cb-is-gen-separate',
});
